import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';



@Component({
  selector: 'app-footer',
  imports: [CommonModule, RouterLink],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {


  items=[
    'Home',
    'Products',
    'Categories',
    'Occasions',
    'Contact',
    'About',
    'Terms & Conditions',
    'Privacy Ploicy',
    'FAQs'
 ]
}
